import React, { useRef } from 'react'
import { OverlayPanel } from 'primereact/overlaypanel'
import LuxButton from '../buttons/Button'
import { MenuItem } from 'primereact/menuitem/menuitem'
import '../menus/menu.scss'

const DropdownMenu = (props: {
    text: string
    items: MenuItem[]
    icon?: string
    variant?: string[]
    panelClasses?: string
}) => {
    const { items, icon, text, variant, panelClasses } = props
    // menu item must provide 'label' and 'command', possibly an 'icon'
    const menu = useRef(null)
    const op = useRef(null)
    return (
        <div>
            <OverlayPanel
                ref={op}
                appendTo={document.body}
                className={`wardrobe-dropdownmenu-op ${panelClasses}`}>
                {items.map((i, index) =>
                    i.template ? (
                        i.template
                    ) : (
                        <LuxButton
                            key={index}
                            icon={i.icon}
                            text={i.label}
                            variant={['text']}
                            disabled={i.disabled}
                            classes={i.className}
                            onClick={(e) => i.command(e)}
                        />
                    )
                )}
            </OverlayPanel>
            <LuxButton
                text={text}
                icon={icon}
                onClick={(e) => op.current.toggle(e)}
                variant={variant ? variant : ['outlined']}
            />
        </div>
    )
}

export default DropdownMenu
